<template>
    <a v-if="postIndex % 10 == 0" :href="post.Url" class="card card-blog-extended text-decoration-none text-dark h-100">
        <div class="row">
            <div class="col-xxl-6 col-sm-12">
                <img :src="`${post.ImageUrl}`" class="card-img-top" alt="Blog post thumbnail" />
            </div>
            <div class="col-xxl-6 col-sm-12">
                <div class="card-body h-100 d-flex flex-column justify-content-between">
                    <div>
                        <p class="small card-subtitle">
                            {{post.PublicationDate}}
                        </p>
                        <h3 class="card-title text-bold mt-2">{{post.Title}}</h3>
                        <p class="card-content mt-4 d-none d-xxl-block">
                            {{post.Summary}}
                        </p>
                    </div>
                    <div class="d-flex justify-content-end mt-2 mt-lg-0">
                        <button v-for="(category, categoryIndex) in post.Tags" :key="categoryIndex" type="button" class="btn btn-round">{{category}}</button>
                    </div>
                </div>
            </div>
        </div>
    </a>
    <a v-else :href="post.Url" class="card card-blog text-decoration-none text-dark h-100">
        <div class="d-none d-lg-block">
            <img :src="`${post.ImageUrl}`" class="card-img-top" alt="Blog post thumbnail" />
            <div class="card-body">
                <p class="small card-subtitle">
                    {{post.PublicationDate}}
                </p>
                <h4 class="card-title text-bold">{{post.Title}}</h4>
                <div class="d-flex justify-content-end">
                    <button v-for="(category, categoryIndex) in post.Tags" :key="categoryIndex" type="button" class="btn btn-round">{{category}}</button>
                </div>
            </div>
        </div>
        <div class="d-block d-lg-none p-3">
            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <img :src="`${post.ImageUrl}`" class="card-img-top" alt="Blog post thumbnail" />
                    <p class="small card-subtitle align-self-end ms-2">
                        {{post.PublicationDate}}
                    </p>
                </div>
                <div>
                    <div v-for="(category, categoryIndex) in post.Tags" class="card-body p-0" :key="categoryIndex">
                        <button type="button" class="btn btn-round">{{category}}</button>
                    </div>
                </div>
            </div>

            <div class="card-body p-0 mt-3">
                <h4 class="card-title text-bold">{{post.Title}}</h4>
                <hr />
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        name: 'BlogPostCard',
        props: {
            post: {
                type: Object,
                required: true,
            },
            postIndex: {
                type: Number,
                required: true,
            }
        },
        setup(props) {
            return {};
        },
    };
</script>

<style lang="scss" scoped></style>